var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9749 21.0119L9.93104 16.9681L5.88723 12.9243C4.97607 11.9829 4.83536 10.5372 5.5479 9.43779C6.23755 8.24393 7.47601 7.47146 8.85152 7.3772C10.7064 7.41412 12.8285 7.78686 14.1524 6.46295L18.9751 1.6385C19.8426 0.759395 21.2578 0.747602 22.1398 1.61213L25.287 4.754C26.1515 5.63604 26.1397 7.0512 25.2606 7.91872L20.4362 12.7484C19.1123 14.0723 19.4867 16.1945 19.5219 18.0493C19.4271 19.4242 18.6547 20.6619 17.4613 21.3512C16.3619 22.0638 14.9162 21.923 13.9749 21.0119Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.66906,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector-29"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93164 16.9715L1.31656 25.5866L9.93164 16.9715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93164 16.9715L1.31656 25.5866",
    stroke: "white",
    strokeWidth: 1.66906,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.f434703312163c60019b5b1a4fc9652d.svg";
export { ForwardRef as ReactComponent };